export default __webpack_public_path__ + "static/kevin-85791d4ad42592557d8b6fa7fb61df08.png";